import { render, staticRenderFns } from "./chooseDeptMember.vue?vue&type=template&id=53675809&scoped=true"
import script from "./chooseDeptMember.vue?vue&type=script&lang=js"
export * from "./chooseDeptMember.vue?vue&type=script&lang=js"
import style0 from "./chooseDeptMember.vue?vue&type=style&index=0&id=53675809&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53675809",
  null
  
)

export default component.exports